import { evidenceItems } from '@/mocks/cg51';
import SectionHeading from './SectionHeading';

const statusMap: Record<string, { label: string; cls: string }> = {
  已核验: { label: '已核验 · 可引用', cls: 'bg-primary-100 text-primary-700' },
  待复核: { label: '待复核', cls: 'bg-accent-100 text-accent-800' },
  存疑: { label: '存疑 · 暂不计入', cls: 'bg-secondary-100 text-secondary-800' },
};

export default function Evidence() {
  return (
    <section id="evidence" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          overline="实锤库"
          title="证据不是越多越好，分级才算数"
          note="每一条进入讨论的支撑都按核验程度打上等级。只有多来源命中的条目才会被用于下结论，存疑内容安静地躺在一旁等待补充。"
        />

        <div className="grid grid-cols-1 gap-4 md:gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {evidenceItems.map((ev) => {
            const status = statusMap[ev.status];
            return (
              <article
                key={ev.code}
                className="flex flex-col rounded-lg border border-background-200/80 bg-background-100 p-5 md:p-6 transition-colors hover:border-primary-200"
              >
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2 text-xs font-semibold tracking-wide text-foreground-600">
                    <i className="ri-folder-2-line text-sm text-secondary-600" />
                    {ev.code} · {ev.label}
                  </span>
                  <span className="flex h-2 w-2 rounded-full bg-accent-500" />
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{ev.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{ev.text}</p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200/80 pt-4">
                  <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${status.cls}`}>
                    {status.label}
                  </span>
                  <a
                    href="#evidence"
                    className="inline-flex items-center gap-1 text-xs font-medium whitespace-nowrap text-foreground-600 hover:text-primary-600"
                  >
                    查看依据
                    <i className="ri-arrow-right-s-line text-sm" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}